import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/index.vue';
import {
  getToken,
  setToken,
  removeToken,
  getStoreId,
  setStoreId,
  removeStoreId,
  setUserInfo,
  getUserInfo,
  removeUserInfo
} from '@/utils/cookies';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
      meta: { title: '润泽水驿', hidden: true, notNeedAuth: true }
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { title: '润泽水驿', hidden: true, notNeedAuth: true }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/store',
      children: [
        {
          path: 'store',
          component: () =>
            import(/* webpackChunkName: "store" */ '@/views/store/index.vue'),
          meta: {
            title: '商户管理',
            icon: 'icon-shop',
            menuGroup: 'root'
          }
        },
        {
          path: 'dashboard',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
          name: 'Dashboard',
          meta: {
            title: '工作台',
            icon: 'dashboard',
            affix: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: '/statistics',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/statistics/index.vue'),
          meta: {
            title: '数据统计',
            icon: 'icon-statistics',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'user',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/user/index.vue'),
          meta: {
            title: '用户管理',
            icon: 'icon-employee',
            requiresStore: false,
            menuGroup: 'root'
          }
        },
        {
          path: 'order',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/orderDetails/index.vue'),
          meta: {
            title: '订单管理',
            icon: 'icon-order',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'courierAssign',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/courierAssign/index.vue'),
          meta: {
            title: '派送记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'category',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/category/index.vue'),
          meta: {
            title: '分类管理',
            icon: 'icon-category',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'dish',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/dish/index.vue'),
          meta: {
            title: '商品管理',
            icon: 'icon-dish',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'purchaseNotice',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/purchaseNotice/index.vue'),
          meta: {
            title: '购买须知',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'homeBanner',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/homeBanner/index.vue'),
          meta: {
            title: '首页轮播',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: '/dish/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/dish/addDishtype.vue'),
          meta: {
            title: '添加商品',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'setmeal',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/setmeal/index.vue'),
          meta: {
            title: '特惠套餐',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'coupon',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/coupon/index.vue'),
          meta: {
            title: '优惠券管理',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'userCoupon',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/userCoupon/index.vue'),
          meta: {
            title: '优惠券发放记录',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'rechargeRule',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/rechargeRule/index.vue'),
          meta: {
            title: '充值规则管理',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'inviteReward',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/inviteReward/index.vue'),
          meta: {
            title: '邀请返余额',
            icon: 'icon-combo',
            // 每桶 2 元已写死后端，配置页隐藏；保留路由以免旧书签报错
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'waterVoucher',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/waterVoucher/index.vue'),
          meta: {
            title: '实惠套餐商品',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'bucketGiftTier',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/bucketGiftTier/index.vue'),
          meta: {
            title: '套餐赠送档位',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'inviteRewardLog',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/inviteReward/log.vue'),
          meta: {
            title: '邀请返现记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'waterVoucherPurchase',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/waterVoucherPurchase/index.vue'),
          meta: {
            title: '套餐购买记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'userWaterQuota',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/userWaterQuota/index.vue'),
          meta: {
            title: '剩余套餐数量',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'waterBucketUse',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/waterBucketUse/index.vue'),
          meta: {
            title: '额度抵扣记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'emptyBucketRecord',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/emptyBucketRecord/index.vue'),
          meta: {
            title: '空桶配送/回收记录',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'emptyBucketRefund',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/emptyBucketRefund/index.vue'),
          meta: {
            title: '退桶退押金申请',
            icon: 'icon-combo',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'walletRecord',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/walletRecord/index.vue'),
          meta: {
            title: '充值记录',
            icon: 'icon-combo',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'employee',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/employee/index.vue'),
          meta: {
            title: '人员管理',
            icon: 'icon-employee',
            requiresStore: false,
            menuGroup: 'root'
          }
        },
        {
          // 默认不出现在侧栏；控制台：localStorage.setItem('adminShowOperationLog','1') 后刷新
          path: 'operationLog',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/operationLog/index.vue'),
          meta: {
            title: '操作日志',
            icon: 'icon-employee',
            requiresStore: false,
            menuGroup: 'root',
            hidden: true
          }
        },

        {
          path: '/employee/add',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/employee/addEmployee.vue'),
          meta: {
            title: '添加人员',
            hidden: true,
            requiresStore: false,
            menuGroup: 'root'
          }
        },

        {
          path: '/setmeal/add',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/setmeal/addSetmeal.vue'),
          meta: {
            title: '编辑特惠套餐',
            hidden: true,
            requiresStore: true,
            menuGroup: 'store'
          }
        },

        {
          path: 'inform',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/inform/index.vue'),
          meta: {
            title: '通知中心',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store'
          }
        },
        {
          path: 'notice',
          component: () =>
            import(/* webpackChunkName: "shopTable" */ '@/views/notice/index.vue'),
          meta: {
            title: '广告弹窗',
            icon: 'icon-inform',
            requiresStore: true,
            menuGroup: 'store'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
});

export default router;
